import {
  Component,
  Input,
  ViewChild,
  ViewChildren,
} from "@angular/core";



@Component({
  selector: "crem-card",
  template: `<mat-card [id]="id" class="cremCard"
    ><mat-card-header>{{title }}</mat-card-header>
    <mat-card-content class="cremCardContent"
      ><ng-content></ng-content>
       </mat-card-content></mat-card>
      `,
  styleUrls: ["./card.component.scss"],
})
export class CardComponent  {
  @Input() public title: string;
  @Input() public id: string;


}
